import React from 'react';

export default function ControlUnitEventsPage() {
  return <div>ControlUnitEventsPage: Work in progress</div>;
}
